import React from 'react';
import { Box, Grid, Paper, Typography, CircularProgress } from '@mui/material';

const RefundDeductionCountBoxes = ({ loading, datas ={}, isNonEnrollment }) => {
  const { total_sale_amount, total_collected_amount, total_refunded_amount } = datas;
  const {
    total_sales_amount,
    session_completed_deduction,
    gst_deduction,
    admission_fee_deduction,
    net_refund_paid,
    fee_collected,
  } = datas;

  const ArrayOfContents = [
    ...(isNonEnrollment
      ? [
          { title: 'Total Sale Amount', value: total_sale_amount },
          { title: 'Total Collected Amount', value: total_collected_amount },
          { title: 'Total Refunded Amount', value: total_refunded_amount },
        ]
      : [
          { title: 'Total Sale Amount', value: total_sales_amount },
          { title: 'Deduction - Session Completed', value: session_completed_deduction },
          { title: 'Deduction - GST', value: gst_deduction },
          { title: 'Deduction - Admin Fee', value: admission_fee_deduction },
          { title: 'Net Refund Paid', value: net_refund_paid },
          { title: 'Fee Collected', value: fee_collected },
        ]),
  ];

  return (
    <Grid container spacing={2}>
      {ArrayOfContents.map((item, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Paper
            elevation={3}
            sx={{
              p: 2,
              borderRadius: 2,
              minHeight: 90,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Typography variant="subtitle2" color="text.secondary">
              {item.title}
            </Typography>

            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                <CircularProgress size={22} />
              </Box>
            ) : (
              <Typography variant="h6" fontWeight={600}>
                {item.value ?? '--'}
              </Typography>
            )}
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default RefundDeductionCountBoxes;
